export const confidenceText = ticket => (
  ticket?.confidence_score == null ? 'Not scored' : `${ticket.confidence_score}%`
);

export default function ConfidenceBadge({ ticket }) {
  return (
    <span
      className={`status-chip ${ticket?.confidence || ''}`}
      title={ticket?.confidence_explanation || undefined}
    >
      {confidenceText(ticket)}
    </span>
  );
}
